module.exports = __webpack_public_path__ + "media/src/assets/images/property_photo3-282a5e3894e4bdf90fcd790661496b5a.jpg";